import React from 'react'
import RightArrow from '../../assets/components/RightArrow'
import { Link } from 'gatsby'

const SimpleStrokeCard = ({ cardHeader, cardText, cardIcon, cardLink, useIconBg }) => {
    return (
        <div className='bg-white flex flex-col justify-start px-5 py-8 gap-5 border-t-[5px] border-brandGreen rounded-lg shadow-strokeCard tablet:px-8 tablet:pb-8 tablet:pt-[72px] tablet:gap-8'>
            {
                useIconBg ?
                    <div className='w-fit border-2 p-4 rounded-[10px] border-brandDarkGray30 shadow-iconShadow'>
                        <img src={cardIcon} alt='icon' className='h-[32px] w-[32px]' />
                    </div>
                    :
                    <img src={cardIcon} alt='icon' className='h-[50px] w-[50px] tablet:h-[80px] tablet:w-[80px]' />
            }
            <div className='flex flex-col gap-3 break-words'>
                <p className='text-fontSize6-bold text-brandPurple tablet:text-fontSize9'>{cardHeader}</p>
                <p className='text-fontSize4 text-brandDarkBlue1 tablet:text-fontSize5'>{cardText}</p>
                {
                    cardLink &&
                    <Link className='flex items-center gap-2 text-fontSize4-bold text-brandPurple cursor-pointer w-fit' to={cardLink}>
                        Learn More <RightArrow size={20} />
                    </Link>
                }
            </div>
        </div>
    )
}

export default SimpleStrokeCard